<template>
  <div v-if="amReady">
    <el-row>
      <div class="mb-5 border-bottom" v-if="formHeader">
        <h3>{{ ((!editMode) ? $ml.get('create') : $ml.get('edit')) + ' ' + module.info.caption }}</h3>
      </div>
    </el-row>

    <el-row class="mb-0 pb-0">
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 16 : 16" class="m-0 p-0"
              style="position:absolute;top: -60px; left:0px;">
        <dg-radio-field
            :control="control"
            :defaultValue="defaultDivisionValue"
            :disabled="(defaultDivision)?true :false"
            :field_span="20"
            :label_span="24"
            :options="divisionsList"
            :translateLabel="false"
            :translateLabels="false"
            @amUpdated="divisionUpdated"
            field_mark=""
            label=""
            name="division_id"
            rules="required"
            v-show="allowDivisionChanging"></dg-radio-field>
        <!--<dg-select-field
            :control="control"
            :defaultValue="defaultDivisionValue"
            :disabled="(defaultDivision)?true :false"
            :field_span="20"
            :label_span="24"
            :options="divisionsList"
            :translateLabel="false"
            :translateLabels="false"
            @amUpdated="divisionUpdated"
            field_mark="required"
            label="Division"
            name="division_id"
            rules="required"></dg-select-field>-->
      </el-col>

      <div class="mt-0 mb-0" v-if="dataModel.division_id">
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4"
                v-if="searchByVendorOption && !defaultDestination">
          <dg-select-field
              :control="control"
              :defaultValue="defaultVendorValue"
              :disabled="(defaultVendorValue)?true :false"
              :field_span="24"
              :label_span="24"
              :options="vendorsDropdownList"
              :translateLabel="false"
              :translateLabels="false"
              @amUpdated="vendorUpdated"
              class="mt-0 mb-0"
              field_mark="required"
              htmlautocomplete="new-password"
              label="Vendor"
              labelProperty="label"
              name="vendor_id"
              placeholder="Vendor"
              rules="required"
              valueProperty="value"
          ></dg-select-field>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
          <dg-select-field
              :control="control"
              :defaultValue="defaultDestinationValue"
              :disabled="(defaultDestination)?true :false"
              :field_span="24"
              :label_span="24"
              :options="destinationsDropDownList"
              :translateLabel="false"
              :translateLabels="false"
              @amUpdated="destinationUpdated"
              class="mt-0 mb-0"
              field_mark="required"
              htmlautocomplete="new-password"
              label="Destination"
              labelProperty="label"
              name="destination_id"
              placeholder="Canada / ATI"
              rules="required"
              valueProperty="value"
          ></dg-select-field>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4" class="mt-0 mb-0"
                v-if="!searchByVendorOption || defaultDestination || true">
          <dg-select-field
              :control="control"
              :defaultValue="defaultRateValue"
              :disabled="(defaultRate)?true :false"
              :field_span="24"
              :label_span="24"
              :options="destinationRateDropDownList"
              :translateLabel="false"
              :translateLabels="false"
              @amUpdated="rateUpdated"
              class="mt-0 mb-0"
              field_mark="required"
              label="Rate"
              name="rate_id"
              rules="required"></dg-select-field>

          <!--<dg-select-field
              :control="control"
              :field_span="22"
            :label_span="22"
              :options="fusionServerList"
              :translateLabels="false"
              field_mark="required"
              label="fusion_server"
              name="pbx_server_url"
              rules="required"></dg-select-field>-->
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 3 : 3" class="mt-0 mb-0">
          <dg-select-field
              :control="control"
              :defaultValue="lastSelectedTestType"
              :field_span="24"
              :label_span="24"
              :options="userTestingPanelSetting"
              :translateLabel="false"
              :translateLabels="false"
              @amUpdated="testTypeUpdated"
              class="mt-0 mb-0"
              field_mark="required"
              label="Test Type"
              name="call_test_type"
              rules="required"></dg-select-field>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 3 : 3" class="mt-0 mb-0">
          <dg-text-field
              :control="control"
              :defaultValue="lastSelectedCallerId"
              :field_span="24"
              :label_span="24"
              :translateLabel="false"
              @amUpdated="callerIdUpdated"
              class="mt-0 mb-0"
              field_mark="required"
              label="Caller ID"
              name="bc_caller_id_number"
              placeholder="001 9421 8273 56"
              rules="required"></dg-text-field>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 3 : 3">
          <dg-label-field label="Effective" :translate="false"></dg-label-field>
          <div class="fake-input-field">
            {{ selectedRateEffectiveDate }}
          </div>
        </el-col>
        <!--<el-col :class="$langConfig.cssClass" :span="(!editMode)? 3 : 3" class="mt-0 mb-0">
          <dg-label-field :translate="false" label="Created Date"></dg-label-field>
          <div class="fake-input-field">
            {{ selectedRateEffectiveDate }}
          </div>
        </el-col>-->
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 3 : 3" v-if="isUserRoot || isUserPlatformEmployee">
          <dg-label-field :translate="false" label="Status"></dg-label-field>
          <div class="fake-input-field-no-spaces"  style="position: relative;top: -5px">
            <div>
              <callTestStatusViewer :callTestStatus="selectedRateStatus" class="fake-input-field"
                                    v-if="selectedRateStatus"></callTestStatusViewer>
            </div>
          </div>
        </el-col>
      </div>
    </el-row>
    <!-- <el-row>
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 5 : 5">
          <dg-label-field label="Mobile Country Code (MCC)" :translate="false"></dg-label-field>
          <div class="fake-input-field">
            {{ mcc }}
          </div>
        </el-col>
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 5 : 5">
          <dg-label-field label="Mobile Network Code (MNC)" :translate="false"></dg-label-field>
          <div class="fake-input-field">
            {{ mnc }}
          </div>
        </el-col>
    </el-row> -->
    <el-row class="mt-2 pt-0 mb-0" v-if="dataModel.division_id">
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 14 : 14" class="mt-0 pt-0">
        <dg-text-field
            :control="control"
            :defaultValue="lastSelectedPhoneNumbers"
            :field_span="22"
            :label_span="24"
            :translateLabel="false"
            @amUpdated="phoneNumbersUpdated"
            class="mt-0 pt-0"
            field_mark="required"
            field_master_container_style="margin-bottom:0px;"
            label="Phone Numbers"
            name="bc_phone_numbers"
            placeholder="00123 456 789, 0012456 7890"
            rows="6"
            rules="required"
            type="textarea">
          <template slot="field_note">
            <sub>phone numbers separated with comma " , "</sub>
          </template>
        </dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 10 : 10" class="pt-2">
        <el-row v-if="selectedRate">
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 5 : 5">
            <dg-select-field
                :control="control"
                :defaultValue="1"
                :field_span="20"
                :label_span="20"
                :options="numbersToGenerateOptions"
                :translateLabel="false"
                :translateLabels="false"
                field_mark=""
                label="Count"
                labelProperty="label"
                name="numbers_to_generate"
                placeholder="Canada / ATI"
                valueProperty="value"
            ></dg-select-field>
          </el-col>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 9 : 9" class="pt-1">
            <el-button @click="generateNumbers" class="d-inline-block mt-4" size="small"
                       style="background-color: #939052"
                       type="info">Generate
              Numbers
            </el-button>
          </el-col>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 7 : 7" v-if="isUserRoot || isUserPlatformEmployee || isUserSales">
            <dg-text-field
                :control="control"
                :field_span="24"
                :label_span="24"
                :translateLabel="false"
                class="p-0"
                field_mark=""
                inputClass=""
                label="Length"
                name="numbers_to_generate_length"
                placeholder=""
                rules=""
                style="max-width: 100px;"></dg-text-field>
          </el-col>
        </el-row>
        <el-row v-if="selectedRate">
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 5 : 5">
            <dg-select-field
                :control="control"
                :defaultValue="1"
                :field_span="20"
                :label_span="20"
                :options="databaseNumbersToGetOptions"
                :translateLabel="false"
                :translateLabels="false"
                field_mark=""
                label="Count"
                labelProperty="label"
                name="numbers_to_get"
                placeholder=""
                valueProperty="value"
            ></dg-select-field>
          </el-col>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 9 : 9" class="pt-1">
            <el-button @click="getNumbers" class="d-inline-block mt-4" size="small" style="background-color: #939052"
                       type="info">Database Numbers
            </el-button>
          </el-col>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4" class="mt-0 pt-0"
                  v-loading="loadingRequests">
            <dg-button
                :click="createModule"
                :text="actionButtonLabel"
                :type="actionButtonType"
                class="text-capitalize"
                icon=""
                style="margin-top: 27px; padding: 9px 29px !important;"></dg-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <div class="mb-4 mt-3" style="border-top: 1px solid #cccccc">
      <el-row :key="callkey" class="mt-2 mb-5" v-for="(callData, callkey) in callsStackReversed">
        <callTestResultsTable :liveDataResults='callsStack[callData].cdr' :broadcastPublicId="broadcastPublicId" :callTestRequest='callsStack[callData].callTestRequest' :testFinalStatus="callsStack[callData].testFinalStatus"
                              :numberOfCalls="callsStack[callData].number_of_calls"></callTestResultsTable>
      </el-row>
    </div>
  </div>
</template>

<script>


import {notify} from '@/system-services/notify.js'
import iziToast from 'izitoast'
import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import module from './../index.js'
import panelMixin from '@/app/portals/cpanel/mixins/util'
import databaseNumbersOptions from './databaseNumbersToGetOptions.json'
import generateNumbersOptions from './generateNumbersOptions.json'

export default {
  components: {
    callTestStatusViewer: () => import('@/components/call-test-status-viewer/View'),
    callTestResultsTable: () => import('@/components/call-test-results-table/View'),
    /*callTestResults: () => import('./../call-test-results/View'),*/
  },
  mixins: [fieldController, panelMixin],
  props: {
    defaultDivision: {
      default: false,
    },
    allowDivisionChanging: {
      default: false,
    },
    defaultDestination: {
      default: false,
    },
    defaultRate: {
      default: false,
    },
    formHeader: {
      default: false,
    },
    editMode: {
      required: true,
      type: Boolean
    },
    onEditCallback: {
      required: false
    },
    onCreateCallback: {
      required: false
    }
  },
  data() {
    return {
      isUserSales: $store.getters['user-state/isUserSales'],
      isUserRoot: $store.getters['user-state/isUserRoot'],
      isUserPlatformEmployee: $store.getters['user-state/isUserPlatformEmployee'],
      testFinalStatus: 0,
      makingTestByPropertyName: 'destination_id',
      defaultRouteDivision: this.$route.params.division,
      selectedVendor: null,
      broadcastsIdsStack: [],
      callsStack: {},
      callsStackReversed: [],
      defaultVendorValue: null,
      defaultDivisionValue: null,
      defaultDestinationValue: null,
      defaultRateValue: null,
      isUserReseller: $store.getters['user-state/isUserReseller'],
      isUserCustomer: $store.getters['user-state/isUserCustomer'],
      currentDomain: process.env.VUE_APP_CURRENT_DOMAIN,
      isUserMrt: $store.getters['user-state/isUserMrt'],
      broadcastPublicId: null,
      componentIsActive: true,
      liveDataResults: [],
      currentBroadcastId: null,
      broadcast: null,
      selectedRate: null,
      selectedRateStatus: null,
      selectedRateEffectiveDate: null,
      numbersToGenerateOptions: generateNumbersOptions,
      databaseNumbersToGetOptions: databaseNumbersOptions,
      divisionsList: [],
      vendorsDropdownList: [],
      destinationsDropDownList: [],
      destinationRateDropDownList: [],
      mcc : null,
      mnc : null,
      userTestingPanelSetting: [],
      control: this,
      amReady: false,
      module: {
        ...module
      },
      dataModel: {
        destination_id: null,
        division_id: null,
        number_length: '',
        numbers_to_generate_length: ''
      },
      fusionServerList: []
    }
  },
  beforeDestroy() {
    this.componentIsActive = false
  },
  computed: {
    sharedCallDetailsId: function () {
      return this.currentDomain + '/shared/call-details/' + this.broadcastPublicId + (($store.getters['user-state/isUserMrt']) ? ('-' + Math.floor(Math.random() * 9999999)) : '')
    },
    ...$mapState('voip-testing-panel-state', ['searchByVendorOption']),
    ...$mapState('ajaxManager', ['loadingRequests']),
    ...$mapState('voip-testing-panel-state',
        [
          'lastSelectedDivision',
          'lastSelectedDestination',
          'lastSelectedRate',
          'lastSelectedTestType',
          'lastSelectedCallerId',
          'lastSelectedPhoneNumbers']),
    actionButtonIcon: function () {
      if (!this.editMode) {
        return 'el-icon-phone';
      } else {
        return 'el-icon-phone-outline'
      }
    },
    actionButtonLabel: function () {
      if (!this.editMode) {
        return 'make_test';
      } else {
        return 're-test'
      }
    },
    actionButtonType: function () {
      if (!this.validData) {
        return 'danger text-white font-weight-bold';
      } else {
        return 'btn btn-warning text-dark font-weight-bold'
      }
    }
  },
  beforeMount() {
    if (this.isUserCustomer || this.isUserReseller) {
      this.makingTestByPropertyName = 'dialcode'
    }

    this.dataModel.makingTestByPropertyName = this.makingTestByPropertyName


    this.$store.dispatch('user-api/getUserSettingFusionIP').then(r => {
      $store.state['user-state'].ourVOSIP = r
    })

    if (this.defaultDivision) {
      this.defaultDivisionValue = this.defaultDivision
    } else {
      this.defaultDivisionValue = this.lastSelectedDivision
    }

    if (this.defaultDestination) {
      this.defaultDestinationValue = this.defaultDestination
    } else {
      this.defaultDestinationValue = this.lastSelectedDestination
    }

    if (this.defaultValue) {
      this.defaultVendorValue = this.defaultValue
    } else {
      this.defaultVendorValue = this.lastSelectedVendor
    }

    if (this.defaultRate) {
      this.defaultRateValue = this.defaultRate
    } else {
      //this.defaultRateValue = this.lastSelectedRate
    }

    this.panelMixin_getUserVoipDivision('divisionsList', (result) => {
      let r = result
      for (let d in r) {
        if (r[d].label == this.defaultRouteDivision) {
          this.defaultRouteDivision = r[d].value
          this.panelMixin_getVendorsDropdownByDivision('vendorsDropdownList', {divisionId: this.defaultRouteDivision})
        }
      }
      this.amReady = true
    })

    this.getViewDestinations()
    this.getUserTestingPanelTestTypes().then((r) => {
      this.userTestingPanelSetting = r.data
    })

    $store.watch(function (state) {
          return state['voip-testing-panel-state'].searchByVendorOption;
        },
        (val) => {
          if (val) {
            this.destinationsDropDownList = []
          } else {
            this.selectedVendor = null
            this.getViewDestinations()
          }
        }, {deep: false});
  },
  methods: {
    getViewDestinations() {
      if (this.isUserCustomer || this.isUserReseller) {
        let apiData = {}
        if (this.defaultRouteDivision) {
          apiData.division_name = this.defaultRouteDivision
        } else if (this.defaultDivision) {
          apiData.division_id = this.defaultDivision
        }

        this.getWorkingDestinationsDropdownlist(apiData).then((r) => {
          this.destinationsDropDownList = r
        })

      } else {
        this.panelMixin_getDestinations('destinationsDropDownList')
      }
    },
    showLiveResults(broadcastId, iteration) {
      setTimeout(() => {
        this.getBroadcastCdr({id: broadcastId, live: true}).then(response => {
          let cdr = response.data
          this.liveDataResults = false
          if (cdr.cdr_json) {
            this.liveDataResults = JSON.parse(cdr.cdr_json)
          }
          if (this.liveDataResults) {
            $vue.set(this.callsStack, broadcastId, {
              cdr: this.liveDataResults,
              number_of_calls: cdr.number_of_calls,
              testFinalStatus: cdr.system_call_test_status_id,
              callTestRequest: cdr
            })
          }
          if (iteration < 60 && this.componentIsActive && this.currentBroadcastId == broadcastId && (cdr.number_of_calls != this.liveDataResults.length || !this.liveDataResults)) {
            iteration += 1
            this.showLiveResults(broadcastId, iteration)
          }
        })
      }, 6000)
    },
    phoneNumbersUpdated(inputField) {
      let value = inputField.field.field_value

      this.testingToolsSetState({
        key: 'lastSelectedPhoneNumbers',
        value: value
      })
    },
    callerIdUpdated(inputField) {
      let value = inputField.field.field_value

      this.testingToolsSetState({
        key: 'lastSelectedCallerId',
        value: value
      })
    },
    testTypeUpdated(inputField) {
      let value = inputField.field.field_value

      this.testingToolsSetState({
        key: 'lastSelectedTestType',
        value: value
      })
    },
    rateUpdated(inputField) {
      let value = inputField.field.field_value

      this.testingToolsSetState({
        key: 'lastSelectedRate',
        value: value
      })

      if (value) {
        this.selectedRate = value
        this.getRatePanelInfo({rateId: value}).then((r) => {
          this.selectedRateStatus = r.data.call_test_status_id
          this.selectedRateEffectiveDate = r.data.effective_date
        })
      }
    },
    getNumbers() {
      this.getNumbersFromDatabase({rate_id: this.selectedRate, limit: this.dataModel.numbers_to_get}).then((r) => {
        this.fields['bc_phone_numbers'].field.field_value = r.data
        this.fields['bc_phone_numbers'].field.validateMessage = ''
        this.fields['bc_phone_numbers'].field.updateValue()
      })
    },
    generateNumbers() {
      this.getGeneratedNumbers({
        rate_id: this.selectedRate,
        limit: this.dataModel.numbers_to_generate,
        number_length: this.dataModel.numbers_to_generate_length,
      }).then((r) => {
        this.fields['bc_phone_numbers'].field.field_value = r.data
        this.fields['bc_phone_numbers'].field.validateMessage = ''
        this.fields['bc_phone_numbers'].field.updateValue()
      })
    },
    vendorUpdated(field) {

      let val = field.field.field_value

      this.selectedVendor = val

      this.testingToolsSetState({
        key: 'lastSelectedVendor',
        value: val
      })

      //this.selectedRate = null
      this.panelMixin_getVendorDestinations({vendorId: val}, (r) => {
        this.destinationsDropDownList = r
        this.defaultRateValue = null
        let rateIn = false

        this.destinationRateDropDownList = []
      })

      this.dataModel.destination_id = null
      this.resetField('destination_id')

      if (this.fields.hasOwnProperty('rate_id')) {
        this.resetField('rate_id')
      }

      this.selectedRateStatus = null
    },
    resetField(fieldName) {
      this.fields[fieldName].field.field_value = ''
      this.fields[fieldName].field.updateValue()
      this.fields[fieldName].field.validateMessage = ''
    },
    destinationUpdated(field) {
      let val = field.field.field_value

      if (!val) return

      this.testingToolsSetState({
        key: 'lastSelectedDestination',
        value: val
      })

      this.selectedRate = null

      this.dataModel.destination_id = field.field.field_value
      this.panelMixin_getDestinationRate({
        id: val,
        divisionId: this.dataModel.division_id,
        vendor_id: this.selectedVendor
      }, (r) => {
        this.destinationRateDropDownList = r
        this.defaultRateValue = null
        let rateIn = false

        if (this.lastSelectedRate) {
          for (let r in this.destinationRateDropDownList) {
            if (this.destinationRateDropDownList[r]['value'] == this.lastSelectedRate) {

              rateIn = true
            }
          }
          if (rateIn) {
            this.fields['rate_id'].field.field_value = this.lastSelectedRate
            this.fields['rate_id'].field.validateMessage = ''
            this.fields['rate_id'].field.updateValue()
            this.defaultRateValue = this.lastSelectedRate
          }
        }
      })
      this.panelMixin_getDestinationMCCMNC({
        id: val,
        divisionId: this.dataModel.division_id,
        vendor_id: this.selectedVendor
      }, (r) => {
        if(r) {
          this.mcc = r.mcc; 
          this.mnc = r.mnc; 
        }
        
        return;
        this.destinationRateDropDownList = r
        this.defaultRateValue = null
        let rateIn = false

        if (this.lastSelectedRate) {
          for (let r in this.destinationRateDropDownList) {
            if (this.destinationRateDropDownList[r]['value'] == this.lastSelectedRate) {

              rateIn = true
            }
          }
          if (rateIn) {
            this.fields['rate_id'].field.field_value = this.lastSelectedRate
            this.fields['rate_id'].field.validateMessage = ''
            this.fields['rate_id'].field.updateValue()
            this.defaultRateValue = this.lastSelectedRate
          }
        }
      })

      if (this.fields.hasOwnProperty('rate_id')) {
        this.resetField('rate_id')
      }

      this.selectedRateStatus = null
    },
    divisionUpdated(inputField) {
      let selectedDivision = inputField.field.field_value

      this.testingToolsSetState({
        key: 'lastSelectedDivision',
        value: selectedDivision
      })

      this.dataModel.destination_id = null
      if (this.fields.hasOwnProperty('destination_id')) {
        this.resetField('destination_id')
      }

      this.dataModel.rate_id = null
      if (this.fields.hasOwnProperty('rate_id')) {
        this.resetField('rate_id')
      }

      this.selectedRateStatus = null

    },
    ...$mapActions('voip-vendor-destination-status-api', {
      getWorkingDestinationsDropdownlist: 'workingDropDownList',
    }),
    ...$mapActions('voip-testing-numbers-api', {
      getNumbersFromDatabase: 'getNumbersFromDatabase',
      getGeneratedNumbers: 'getGeneratedNumbers'
    }),
    ...$mapActions('voip-testing-panel-state', {testingToolsSetState: 'setState'}),
    ...$mapActions('voip-testing-panel-api', {
      getUserTestingPanelTestTypes: 'getUserTestingPanelTestTypes',
      getRatePanelInfo: 'getRatePanelInfo',
      getBroadcastCdr: 'getBroadcastCdr'
    }),
    ...$mapActions('voip-destination-api', {
      getDestinationsDropdownlist: 'getDropDownList',
      getDestinationRate: 'getDestinationRate'
    }),
    createModule() {
      this.validateFields().then(result => {
        this.$store.state['voip-testing-panel-state'].lastBroadcast = {}
        this.$store.state['voip-testing-panel-state'].lastBroadcastId = false

        let context = this;
        let data = {data: this.dataModel};
        if (this.editMode) {
          data.id = this.dataToBind.id;
        }

        if (result) {

          let panelUserTestApi = 'panelUserTest'
          let isUserMRT = $store.getters['user-state/isUserMrt']
          if (isUserMRT) {
            panelUserTestApi = 'panelUserTestMRT'
          }

          let api = (this.editMode) ? 'update' : panelUserTestApi;
          this.$store.dispatch(this.module.info.name + '-api/' + api, data).then(response => {
            iziToast.success({
              title: this.$ml.get('successfully'),
              message: '',
              position: 'topRight',
              close: false,
              timeout: 1900,
              animateInside: true
            });
            return

            this.amReady = false

            if (context.editMode) {
              context.onEditCallback(response.data)
            } else {
              $vue.nextTick(() => {
                context.amReady = true
              })
              if (context.onCreateCallback) {
                context.onCreateCallback(response.data)
              }
            }
            // this.$router.push({ name: this.module.stateName + '-module-list', params: { teacherId: response.data.id}}).then( response => {})
          }).catch(error => {
            let message = JSON.parse(error.response.data.message)
            let broadcastId = message.data.id
            this.broadcastPublicId = message.data.public_id
            this.broadcastsIdsStack.unshift(this.broadcastPublicId)
            let status = message.status

            this.$store.state['voip-testing-panel-state'].lastBroadcast = {}
            this.$store.state['voip-testing-panel-state'].lastBroadcastId = broadcastId

            $vue.set(this.callsStack, broadcastId, {cdr: [], number_of_calls: -1})
            this.callsStackReversed.unshift(broadcastId)
            this.currentBroadcastId = broadcastId
            this.showLiveResults(broadcastId, 0)

            let title = 'failed'
            let type = 'error'
            if (broadcastId) {
              title = 'successfully'
              type = 'success'
            }

            notify({
              type: type,
              title: title,
            });

            let dataMessage = false
            if (this.onCreateCallback) {
              if (this.broadcastPublicId) {
                dataMessage = message
              }
              this.onCreateCallback(dataMessage)
            }

            this.setfieldsErrorMessage({
              fieldsErrors: error.response.data
            }, this.arefieldsValid);
          })
        }
      })
    }
  }
}
</script>

<style>
.show-live-results-data {
  font-size: 11px;
}
</style>
